<template>
  <TheTopBar :controls="controls" with-fullscreen-button />
</template>

<script>
import TheTopBar from '@/components/Gadgets/TheTopBar'
import TopBarControlsSuite from '@/classes/TopBarControls/TopBarControlsSuite'

export default {
  name: 'ExteriorTour360TopBarControls',
  components: {
    TheTopBar,
  },
  computed: {
    controls() {
      return new TopBarControlsSuite({})
    },
  },
}
</script>
